// The hold-fire look registry: one World theme look id in, one recipe out
// (R1439, `ui-map-interface.md` §6.1.7).
//
// One field of a World body names a hold-fire look: `holdFire`, which is
// what an own fleet draws around its hull while it holds fire (R1437). The
// player picks one of five; this module turns the id into the draw code and
// the figure row, and decides nothing else.
//
// **The arithmetic is not here.** `holdfire-recipe-kit.ts` holds the context
// type, the stroke floor and every primitive. This module re-exports the
// kit, so an importer takes one name from one place.
//
// **A look that is not built draws the AUTO look**, recipe and row, the rule
// of the anchoring looks (R1125): `holdfire-recipes.ts` lists it in
// `PENDING`, and every id a player can pick draws something.
//
// This is a leaf (`leaves.test.ts`).

import { HOLD_FIRE_STYLES } from '../gen/balance';
import { HOLD_FIRE_LOOKS } from '../gen/presentation';
import type { HoldFireRow } from '../gen/presentation';
import type { HoldFireRecipe } from './holdfire-recipe-kit';
import { RECIPES, PENDING } from './holdfire-recipes';
import { lookRegistry, type Look, type RecipeFile } from './recipe-kit';

export * from './holdfire-recipe-kit';

/** The World field that names a hold-fire look. */
export const HOLD_FIRE_FIELD = 'holdFire';

/** Every look id, in cycle order. Position 0 is the AUTO look (R822). */
export const HOLD_FIRE_IDS: readonly string[] = HOLD_FIRE_STYLES;

/** The AUTO look: the id every pending look draws. */
export const HOLD_FIRE_AUTO = HOLD_FIRE_IDS[0];

/** One resolved look: the id asked for, its figures and its draw code. */
export type HoldFireLook = Look<HoldFireRow, HoldFireRecipe>;

/** The one recipe file. */
const FILES: readonly RecipeFile<HoldFireRecipe>[] = [{ recipes: RECIPES, pending: PENDING }];

const REGISTRY = lookRegistry(HOLD_FIRE_IDS, FILES, HOLD_FIRE_LOOKS);

/** The look of one id, or the AUTO look for an id this build does not hold. */
export const holdFireLook: (id: string) => HoldFireLook = REGISTRY.look;

/** Which ids the recipe file has built, and which it left pending. */
export const fileHalves = REGISTRY.fileHalves;
